export default "__VITE_ASSET__BWfkapsQ__"